import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate, Outlet } from 'react-router-dom';
import { masterRoutes } from '../../../../routing/routes';
import MasterList from './listView/masterList';
import GuardedRoute from '../guradedRoute';
import { userAuthoritiesArray } from '../../../../services/authorization';
import Audit from './auditView/Audit';
import LiveFeedPreview from '../cameraOnBoarding/liveFeedPreview';
import ScanCameraQr from '../cameraOnBoarding/scanCameraQr';
import creatingCamera from '../cameraOnBoarding/creatingCamera';
import CameraDetails from '../cameraOnBoarding/cameraDetails';
import cameraConfirmDetails from '../cameraOnBoarding/cameraConfirmDetails';
import cameraSuccess from '../cameraOnBoarding/cameraSuccess';
import RouteWrapper from '../../../../routing/RouterWrapper';

const WrapperWithOutlet = () => {
  return <Outlet />;
};

const MasterWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/master') {
      navigate(masterRoutes.DEPOT); // Default redirect on /master
    }
  }, [location.pathname, navigate]);

  return (
    <Routes>
      <Route path="/" element={<WrapperWithOutlet />}>
        <Route path=":masterType/details/:id" element={<RouteWrapper component={Audit} />} />
        <Route path="addCamera" element={<RouteWrapper component={creatingCamera} />} />
        <Route path="scanCameraQr" element={<RouteWrapper component={ScanCameraQr} />} />
        <Route path="livefeedPreview" element={<RouteWrapper component={LiveFeedPreview} />} />
        <Route path="cameraDetails" element={<RouteWrapper component={CameraDetails} />} />
        <Route path="cameraConfirmDetails" element={<RouteWrapper component={cameraConfirmDetails} />} />
        <Route path="cameraSuccess" element={<RouteWrapper component={cameraSuccess} />} />
        <Route
          path=":masterType"
          element={
            <GuardedRoute
              element={<RouteWrapper component={MasterList} />}
              role={userAuthoritiesArray()}
              pathname={location.pathname}
            />
          }
        />

      </Route>
    </Routes>
  );
};

export default MasterWrapper;
